var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('div',[(!_vm.footer)?_c('button',{staticClass:"sm:hidden w-full md:w-auto hover:bg-blue-100 hover:text-blue-900 bg-blue-900 text-white md:bg-transparent md:text-blue-900 font-bold py-2 px-2 mt-2 md:mt-0 inline-flex items-center"},[_c('span',{staticClass:"pl-2"},[_vm._v("Navigation")])]):_vm._e(),_vm._v(" "),_c('ul',{class:_vm.navClass},[_c('NavigationItem',{attrs:{"label":"Overview","link":"overview","footer":_vm.footer}}),_vm._v(" "),(
          !(
            _vm.pageInfo.type == 'councilDistrict' ||
            _vm.pageInfo.sector == 'Alternative' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'opportunity' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'alternative'
          )
        )?_c('NavigationItem',{staticClass:"notranslate",attrs:{"label":"SPREE","link":"spree","footer":_vm.footer}}):_vm._e(),_vm._v(" "),(
          _vm.pageInfo.sector == 'Alternative' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'opportunity' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'citywide' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'opportunity' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'innovation' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'alternative' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'network 12' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'network 14'
        )?_c('NavigationItem',{attrs:{"label":"Alt Ed Progress Report","link":"altedprogressreport","footer":_vm.footer}}):_vm._e(),_vm._v(" "),_c('NavigationItem',{attrs:{"label":"Enrollment & Demographics","link":"demographics","footer":_vm.footer}}),_vm._v(" "),(
          !(
            _vm.pageInfo.type == 'councilDistrict' ||
            _vm.pageInfo.sector == 'Alternative' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'opportunity' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'alternative'
          )
        )?_c('NavigationItem',{attrs:{"label":"Reading & Language Arts","link":"reading","footer":_vm.footer}}):_vm._e(),_vm._v(" "),(
          !(
            _vm.pageInfo.type == 'councilDistrict' ||
            _vm.pageInfo.sector == 'Alternative' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'opportunity' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'alternative'
          )
        )?_c('NavigationItem',{attrs:{"label":"Math & Science","link":"mathscience","footer":_vm.footer}}):_vm._e(),_vm._v(" "),(
          _vm.pageInfo.type == 'citywide' ||
            (_vm.pageInfo.type == 'network' &&
              _vm.pageInfo.slugvalue.toLowerCase() !== 'opportunity') ||
            (_vm.pageInfo.type == 'sector' &&
              _vm.pageInfo.slugvalue.toLowerCase() !== 'alternative') ||
            _vm.pageInfo.type == 'studyArea' ||
            ((_vm.pageInfo.sector == 'Charter' ||
              _vm.pageInfo.sector == 'District') &&
              (_vm.pageInfo.schoolLevel == 'Elementary-Middle-High' ||
                _vm.pageInfo.schoolLevel == 'Middle-High' ||
                _vm.pageInfo.schoolLevel == 'High'))
        )?_c('NavigationItem',{attrs:{"label":"College & Career","link":"collegecareer","footer":_vm.footer}}):_vm._e(),_vm._v(" "),(
          !(
            _vm.pageInfo.type == 'councilDistrict' ||
            _vm.pageInfo.sector == 'Alternative' ||
            _vm.pageInfo.slugvalue.toLowerCase() == 'opportunity'
          )
        )?_c('NavigationItem',{attrs:{"label":"Climate","link":"climate","footer":_vm.footer}}):_vm._e(),_vm._v(" "),(_vm.pageInfo.type != 'councilDistrict')?_c('NavigationItem',{attrs:{"label":"Survey Results","link":"surveyresults","footer":_vm.footer}}):_vm._e(),_vm._v(" "),(
          !(
            _vm.pageInfo.type == 'councilDistrict' || _vm.pageInfo.type == 'studyArea'
          )
        )?_c('NavigationItem',{attrs:{"label":"More Info","link":"moreinfo","footer":_vm.footer}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }